function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#f0f0f0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 9V.05a10.14 10.14 0 00-2 .41V9H.05v1c0 .34 0 .67.05 1H7v8.54A10.14 10.14 0 009 20v-9h11c0-.33.05-.66.05-1s0-.67-.05-1z",
  fill: "#003281"
});

function SvgFi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjBmMGYwO30uY2xzLTJ7ZmlsbDojMDAzMjgxO308L3N0eWxlPjwvZGVmcz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNOSw5Vi4wNUExMC4xNCwxMC4xNCwwLDAsMCw3LC40NlY5SC4wNWMwLC4zMywwLC42NiwwLDFzMCwuNjcuMDUsMUg3djguNTRBMTAuMTQsMTAuMTQsMCwwLDAsOSwyMFYxMUgyMGMwLS4zMy4wNS0uNjYuMDUtMXMwLS42Ny0uMDUtMVoiLz48L3N2Zz4=";
export { SvgFi as ReactComponent };